var SCM = SCM || {};
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

(function (scm, $) {

    scm.HandleMobile = function (isMobile, enabledOnMobile) { };
    var initialSetupComplete = false;
    var pubGradeScriptLoaded = false;

    /**
     * @param {string} slotName
     * @param {number[][]} adSizes
     * @param {string} divId
     * @param {string} targetName
     * @param {boolean} enabledOnMobile
     * @param {boolean} isOutOfPageAd
     * @param {string} positionKeyword
     * @param {boolean} skipSizeMapping
     * @param {string} nativePlacementId
     */
    scm.SetupAd = function (slotName, adSizes, divId, targetName, enabledOnMobile, isOutOfPageAd, positionKeyword, skipSizeMapping, nativePlacementId, suppressDisplay, fallbackDivId, positionTargetingKey) {
        /* Valid partial order for google ads:
         * 1. Define page-level settings
         * 2. Define Slots
         * 3. Add event listeners
         * 4. Enable Services
         * 5. Display Slots
         * */

        scm.HandleMobile(scm.IsMobile(), enabledOnMobile);
        if (!initialSetupComplete) {
            // Set PPID before enableServices if consent granted (ACS-667)
            if (SCM.PpidFrequencyCapping && SCM.PpidFrequencyCapping.SetPpidIfConsented) {
                SCM.PpidFrequencyCapping.SetPpidIfConsented();
            }

            googletag.pubads().enableSingleRequest();
            googletag.pubads().collapseEmptyDivs(true);
            googletag.enableServices();
            initialSetupComplete = true;
        }

        var gptAdSlot = [];
        var slot;
        if (isOutOfPageAd) {
            slot = googletag.defineOutOfPageSlot(slotName, divId);
        } else {
             slot = googletag.defineSlot(slotName, adSizes, divId);
        }
        

        if (slot) {
            slot.addService(googletag.pubads());

            if (adSizes && !skipSizeMapping) {
                slot.defineSizeMapping(BuildAdSizeMappings(adSizes));
            }

            if (targetName) {
                slot.setTargeting(targetName, []);
            }

            if (nativePlacementId) {
                slot.setTargeting('ntvPlacement', [nativePlacementId]);
            }

            if (positionKeyword) {
                slot.setTargeting(positionTargetingKey || 'position', positionKeyword);
            }

            gptAdSlot[0] = slot;
        }

        scm.addClassToSplitView = function (slotElementId) {
            var $slotDiv = $('#' + slotElementId);
            if ($slotDiv.closest('.js-ad-banner').length && $slotDiv.find('*').length) {
                $('.js-splitview-wrapper').addClass('ad-banner-visible');
            }
        };

        googletag.pubads().addEventListener('slotRenderEnded', function (event) {

            if (!event.isEmpty && event.slot === gptAdSlot[0]) {
                scm.addClassToSplitView(event.slot.getSlotElementId());
                $('.js-adblock-advertisement-text').each(function () {
                    var $adblockDiv = $(this).siblings('.js-adblock');
                    if ($adblockDiv && $adblockDiv.is(':visible') && $adblockDiv.find('*').length > 1) {
                        $(this).removeClass('hide');
                    }
                });
            } 

            if (SCM.RevealerAd && SCM.RevealerAd.getDivId && event.slot.getSlotElementId() === SCM.RevealerAd.getDivId()) {
                if (event.size && event.size[0] === 1 && event.size[1] === 1) {
                    SCM.RevealerAd.revealAd();
                } else {
                    // No revealer (empty or non-1x1), fall back to leaderboard
                    SCM.RevealerAd.hideRevealer();
                    if (fallbackDivId) {
                        googletag.cmd.push(function () {
                            googletag.display(fallbackDivId);
                            // The fallback slot was suppressed and excluded from the initial SRA batch,
                            // so refresh it to trigger the ad request
                            var fallbackSlots = googletag.pubads().getSlots().filter(function (s) {
                                return s.getSlotElementId() === fallbackDivId;
                            });
                            if (fallbackSlots.length) {
                                googletag.pubads().refresh(fallbackSlots);
                            }
                        });
                        $('#' + fallbackDivId).parents('.widget-AdBlock').slideDown();
                    }
                }
            }

            // Remove empty carousel ad slides and update navigation
            if (SCM.SelfServeCarousel && SCM.SelfServeCarousel.handleEmptyCarouselAd) {
                SCM.SelfServeCarousel.handleEmptyCarouselAd(event);
            }
        });

        if (!suppressDisplay) {
            if (SCM.pubGradeAdsEnabled) {
                document.addEventListener('pbgrdFinished', function () {
                    googletag.display(divId);
                    googletag.pubads().refresh(gptAdSlot);
                }, { once: true });
            }
            else {
                googletag.display(divId);
                googletag.pubads().refresh(gptAdSlot);
            }
        }

    };

    scm.IsMobile = function() {
        return SCM.SplitScreen && SCM.SplitScreen.getDocWidth() < 767;
    };

    scm.Init = function () {

        // Make sure Google Tag Manager is setup
        if (!googletag.apiReady) {
            return false;
        }

        if (SCM.pubGradeAdsEnabled && !pubGradeScriptLoaded) {
            pubGradeScriptLoaded = true;
            $.getScript(SCM.pubGradeJSLibrary);
        }

        googletag.cmd.push(function () {
            var $adBlocks = $('.hfAdBlockInfo[data-adprovider-typeid=1]');

            // Collect all fallback div IDs — ads targeted as fallbacks should suppress their initial display
            var fallbackTargets = {};
            $adBlocks.each(function (index, item) {
                var fallbackDivId = $(item).data('fallback-divid');
                if (fallbackDivId) {
                    fallbackTargets[fallbackDivId] = true;
                }
            });

            // Initially hide widgets that are fallback targets (shown via slideDown when fallback triggers)
            $adBlocks.each(function (index, item) {
                var $item = $(item);
                var divId = $item.data('divid');
                if (fallbackTargets[divId]) {
                    $item.parents('.widget-AdBlock').hide();
                }
            });

            // Setup each ad on the page
            $adBlocks.each(function (index, item) {
                var $item = $(item);
                var targetName = $item.data('targetname');
                var slotName = $item.data('slotname');
                var adSizes = $item.data('sizes');
                var divId = $item.data('divid');
                var enabledOnMobile = $item.data('enabled-on-mobile');
                var outOfPageAd = $item.data('outofpagead');
                var positionKeyword = $item.data('position-keyword');
                var positionTargetingKey = $item.data('position-targeting-key') || 'position';
                var skipSizeMapping = $item.data('skip-size-mapping');
                var nativePlacementId = $item.data('native-placement-id');

                if (scm.IsMobile() && (enabledOnMobile === 'false' || enabledOnMobile === 'False' || enabledOnMobile === false)) {
                    var $adBlock = $item.siblings('.js-adblock-wrap');
                    $adBlock.addClass('hide');

                    if (SCM.SelfServeCarousel && SCM.SelfServeCarousel.removeCarouselSlide && divId) {
                        SCM.SelfServeCarousel.removeCarouselSlide(divId);
                    }
                }

                var isOutOfPageAd = outOfPageAd === 'true' || outOfPageAd === 'True';
                var shouldSkipSizeMapping = skipSizeMapping === 'true' || skipSizeMapping === 'True' || skipSizeMapping === true;

                var suppressDisplay = $item.data('suppress-display');
                var fallbackDivId = $item.data('fallback-divid');

                // Auto-suppress ads that are fallback targets for another ad (e.g., leaderboard is fallback for revealer)
                var shouldSuppressDisplay = suppressDisplay === true || fallbackTargets[divId];

                if (slotName && divId) {
                    // Skip if this div ID is already registered with GPT (e.g. non-AJAX ads on re-init)
                    var alreadyRegistered = googletag.pubads().getSlots().some(function (s) {
                        return s.getSlotElementId() === divId;
                    });
                    if (alreadyRegistered) { return; }

                    scm.SetupAd(slotName, adSizes, divId, targetName, enabledOnMobile, isOutOfPageAd, positionKeyword, shouldSkipSizeMapping, nativePlacementId, shouldSuppressDisplay, fallbackDivId, positionTargetingKey);
                }
            });
        });
        return true;
    };

    /**
     * @param {number[][]} adSizes
     */
    function BuildAdSizeMappings(adSizes) {

        var mapping = googletag.sizeMapping();

        adSizes.forEach(function (adSize) {
            mapping.addSize([ adSize[0], 0 ], [ adSize ]);
        });

        mapping.addSize([0, 0], []);

        return mapping.build();
    }

    $(function () {
        var apiReady = scm.Init();
        var retryLimit = 5;
        var retryDelayMilliseconds = 500;

        if (!apiReady) {
            setTimeout(retryInit, retryDelayMilliseconds);
        }

        function retryInit() {
            retryLimit--;
            apiReady = scm.Init();
            if (!apiReady && retryLimit > 0) {
                setTimeout(retryInit, retryDelayMilliseconds);
            }
        }

    });

})(SCM.GoogleDoubleclickAds = SCM.GoogleDoubleclickAds || {}, jQuery);
